import { useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import styles from "./Footer.module.css";

const Footer = () => {
  const { lang } = useLang();

  return (
    <footer className={styles.footer}>
      <p>
        © {new Date().getFullYear()} MyApple — {t("footer.rights", lang)}
      </p>
    </footer>
  );
};

export default Footer;
